export interface ExpertReviewandRatingsAction {
  type: string;
}

const expertReviewandRatings = (state = {}, action: ExpertReviewandRatingsAction,) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default expertReviewandRatings;
